import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const getAngularEditorConfig = () => {
  const translateService = inject(TranslateService);

  return {
    editable: true,
    spellcheck: true,
    sanitize: false,
    minHeight: '25rem',
    placeholder: translateService.instant(
      'location.myLocation.location_notification.enter_text'
    ),
    translate: 'no',
    defaultParagraphSeparator: 'p',
    fonts: [{ class: 'teleneo-office', name: 'TeleNeo Office' }],
    defaultFontName: 'TeleNeo Office',
    toolbarHiddenButtons: [
      [
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
      ],
      [
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode',
      ],
    ],
  };
};
